import { LoadingPlaceholderStyled } from './LoadingPlaceholder.styles';

interface LoadingPlaceholderProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  circle?: boolean;
  linesCount?: number;
  margin?: string;
  noAnimation?: boolean;
  width?: string;
}

const LoadingPlaceholder = ({
  circle,
  linesCount,
  margin,
  noAnimation,
  width,
  ...props
}: LoadingPlaceholderProps) => {
  return (
    <LoadingPlaceholderStyled
      $circle={circle}
      $linesCount={linesCount}
      $margin={margin}
      $noAnimation={noAnimation}
      $width={width}
      {...props}
    >
      {'\u200c'}
    </LoadingPlaceholderStyled>
  );
};

LoadingPlaceholder.defaultProps = {
  circle: false,
  linesCount: 1,
  margin: '',
  noAnimation: false,
  width: '',
};

export default LoadingPlaceholder;
